import { useEffect } from "react";

/**
 * Mede a altura real do `.header` (fixed) e publica em `--header-height`.
 * `header-background` (spacer) e `.menu-modal` (dropdown de categorias)
 * dependem dessa variável em vez de valores fixos em px, que ficam
 * desatualizados sempre que o header muda de altura (ex: consolidação do
 * navbar em uma única linha) e deixam um vão cinza (bg do body) visível.
 */
function HeaderHeightSync() {
  useEffect(() => {
    const header = document.querySelector(".header");
    if (!header) return;

    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty(
        "--header-height",
        `${header.getBoundingClientRect().height}px`,
      );
    };

    updateHeaderHeight();
    const observer = new ResizeObserver(updateHeaderHeight);
    observer.observe(header);

    return () => observer.disconnect();
  }, []);

  return null;
}

export default HeaderHeightSync;
